import { Inject, Injectable } from '@angular/core';
import { HttpResponse } from '@angular/common/http';
import { isNil, omit } from 'lodash-es';
import { environment } from '../environments/environment';

import { UtilsService } from './utils.service';
import { SettingsValuesService } from './settings.values.service';

import { $frontendTypes } from './SalesOrders.frontend.types'

@Injectable({ providedIn: 'root' })
export class SalesOrders_get_sales_order_line_availability_flowService {

  constructor(
    private $utils: UtilsService,
    private $settings: SettingsValuesService,
    ) { 
  }

  async run($inParams: { warehouseId: number, materialId: number, packagedId: number, lotId?: number, licenseplateId?: number, serialnumberId?: number, locationId?: number }): Promise<{ availableByMaterial?: number, availableByLot?: number, availableByLicenseplate?: number, availableBySerialnumber?: number, availableHelper?: string, nonallocatableHelper?: string }> 
  {
    const $missingRequiredInParams = [];
    if (isNil($inParams.warehouseId)) {
      $missingRequiredInParams.push('\'warehouseId\'');
    }
    if (isNil($inParams.materialId)) {
      $missingRequiredInParams.push('\'materialId\'');
    }
    if (isNil($inParams.packagedId)) {
      $missingRequiredInParams.push('\'packagedId\'');
    }
    if ($missingRequiredInParams.length) {
    }
    let $url = `${environment.backendUrl}api/`;
    
    const $options = {
    }
    
    const $body = $inParams;
    
    return this.$utils.http.post($url, $body, $options);
    
  }

}

